import { useLanguage } from '../context/LanguageContext';
import { Truck, CalendarClock } from 'lucide-react';

export default function DeliveryInfoBox() {
  const { isRomanian } = useLanguage();

  return (
    <section className="py-8 bg-brand-orange" data-testid="delivery-info-box">
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
          <div className="flex items-center gap-3 text-white">
            <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
              <Truck className="w-7 h-7 text-white" />
            </div>
            <div>
              <p className="font-heading text-xl font-bold">
                {isRomanian ? 'Prima cutie in 2 zile' : 'First box in 2 days'}
              </p>
              <p className="text-white/80 text-sm">
                {isRomanian ? 'Livrare rapida dupa abonare' : 'Fast delivery after subscribing'}
              </p>
            </div>
          </div>
          <div className="hidden md:block h-12 w-px bg-white/30"></div>
          <div className="flex items-center gap-3 text-white">
            <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
              <CalendarClock className="w-7 h-7 text-white" />
            </div>
            <div>
              <p className="font-heading text-xl font-bold">
                {isRomanian ? 'Apoi lunar, in fiecare luna' : 'Then monthly, every month'}
              </p>
              <p className="text-white/80 text-sm">
                {isRomanian ? 'Surprize noi in fiecare luna' : 'New surprises every month'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
